import React from "react";
import { IgFontFamily } from "@intelligems/ig-design-tokens/constants";
import { SxProps } from "@mui/material/styles";

import { IgCopyTextTypography } from "./IgCopyTextTypography";
import { IgTypography, IgTypographyProps } from "./IgTypography";

export const IgMonoText = ({
  value,
  variant = "caption",
  noWrap,
  copyable,
  sx,
  copyValue,
  title,
  color,
  fontWeight,
}: {
  value?: string;
  variant?: IgTypographyProps["variant"];
  noWrap?: boolean;
  copyable?: boolean;
  copyValue?: string;
  color?: string;
  sx?: SxProps;
  title?: string;
  fontWeight?: IgTypographyProps["fontWeight"];
}) => {
  const displayValue = value || "—";
  const mergedSx: SxProps = {
    fontFamily: IgFontFamily.code,
    minWidth: 0,
    fontFeatureSettings: '"tnum" 1, "ss01" 1',
    fontVariantNumeric: "tabular-nums",
    ...(noWrap
      ? {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }
      : { overflowWrap: "anywhere" }),
    ...sx,
  };
  if (copyable) {
    return (
      <IgCopyTextTypography
        text={displayValue}
        customCopyText={copyValue ?? displayValue}
        typographyProps={{ variant, sx: mergedSx, fontWeight, title }}
      />
    );
  }

  return (
    <IgTypography
      variant={variant}
      sx={mergedSx}
      color={color}
      fontWeight={fontWeight}
      title={title}
    >
      {displayValue}
    </IgTypography>
  );
};
